/* ============================================================================
   GT All-Products Catalogue — grid/list view toggle.
   Presentation only: toggles a CSS class on the existing product grid. It never
   changes card markup, selling-unit data or Add-to-Cart behaviour, and re-applies
   the saved view after Shopify's facet/sort Ajax replaces the grid.
   Choice is persisted for the current session (sessionStorage).
   Guarded against double inclusion; uses document-level delegation.
   ========================================================================== */
(function () {
  if (window.__gtAllCatViewInit) return;
  window.__gtAllCatViewInit = true;

  var STORAGE_KEY = 'gt-allcat-view';
  var LIST_CLASS = 'gt-catalog__grid--list';

  function savedView() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === 'list' ? 'list' : 'grid';
    } catch (e) {
      return 'grid';
    }
  }

  function storeView(view) {
    try {
      sessionStorage.setItem(STORAGE_KEY, view);
    } catch (e) {
      /* sessionStorage unavailable — fall back to in-memory only */
    }
  }

  function applyView(view) {
    var grid = document.querySelector('[data-gt-grid]');
    if (grid) {
      grid.classList.toggle(LIST_CLASS, view === 'list');
    }
    document.querySelectorAll('[data-gt-view]').forEach(function (btn) {
      var isActive = btn.getAttribute('data-gt-view') === view;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-gt-view]');
    if (!btn) return;
    var view = btn.getAttribute('data-gt-view') === 'list' ? 'list' : 'grid';
    storeView(view);
    applyView(view);
  });

  function init() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    applyView(savedView());

    // The facet/sort Ajax replaces #ProductGridContainer's contents, which drops
    // the toggled class. Re-apply the saved view whenever the grid is re-rendered.
    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        applyView(savedView());
      });
      observer.observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
